export const TITLE = 'ОНЛАЙН КАЛЬКУЛЯТОР СТОЛЕШНИЦ ИЗ КАМНЯ';

export const TITLE_PART1 =
    'Калькулятор столешницы из искусственного камня производит расчет стоимости, опираясь, в первую очередь, на габариты указанного изделия. Это простой и комфортный сервис, который позволяет узнать предварительную стоимость столешницы через интернет. Онлайн калькулятор столешницы из камня может проанализировать даже сложную и нестандартную модель. Также при подборе столешниц из искусственного камня онлайн калькулятор поможет учесть все доступные параметрыизделия.';

export const TITLE_PART2 = (
    <>
        Приобретение столешницы из искусственного камня с калькулятором в Одессе становится весьма удобным, так как можно заранее увидеть всю желаемую
        информацию в режиме реального времени. Пользователю не нужно звонить консультанту или самостоятельно ехать в центральный офис нашей компании{' '}
        <a href="https://interkam.od.ua">
            <b>Интеркам</b>
        </a>
        . Рассчитать столешницу из искусственного камня на калькуляторе можно весьма быстро, и при этом, процесс не занимает большое количество
        времени. Итог удивит каждого клиента.
    </>
);

export const TITLE_PART3 =
    'Цена, которую выдаст сервис, может быть уменьшена, если позже воспользоваться акцией либо пересмотреть все параметры выбранной модели. Готовое решение всегда формируется на основе действующей стоимости материалов. Рассчитать стоимость столешницы из камня на калькуляторе весьма эффективно. Столешницу из камня можно купить выгодно, если заранее распланировать все нюансы.';

export const TITLE_PART4 =
    'Есть еще несколько нюансов, которые нужно знать, пользуясь калькулятором столешницы из искусственного камня. Каждый вид товара, который представлен в ассортименте на сайте либо непосредственно в магазине, может иметь собственные конструкционные особенности, которые существенно влияют на формирование конечной стоимости покупки. Если пользователь оценивает стандартный вариант, то подобный сервис быстро и эффективно рассчитает цену желаемой покупки. Он уточнит все расходы. Цена конечного изжелия зависит от выбранного цвета камня и наличия дополнительных элементов, их стоимости.';

export const TITLE_PART5 = (
    <>
        Вы хотите узнать, сколько будет стоить изготовление того или иного изделия в компании{' '}
        <a href="https://interkam.od.ua">
            <b>Интеркам</b>
        </a>
        , прежде чем оформлять заказ? Воспользуйтесь функцией онлайн-расчета стоимости столешниц из искусственного камня! Для комфорта наших клиентов
        мы разработали удобный и эффективный калькулятор - он поможет Вам узнать практически точную цену Вашего заказа всего за пару минут.
    </>
);
